<template>
  <div
    class="signature"
    :class="{ selected: selected, positioned: positioned }"
    @click="$emit('click')"
  >
    <div
      v-if="closable"
      @click.stop="$emit('close')"
      @touchstart.stop="$emit('close')"
      class="button-close"
    >
      x
    </div>
    <div>
      <div class="stamp" />
      <div class="data">
        <div>
          <div class="data-item" v-if="name">
            {{ name }}
            <span v-if="positioned" class="text-warning">
              <vs-icon icon="approval"/>
            </span>
          </div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    name: { type: String },
    closable: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    positioned: { type: Boolean, default: false }
  }
};

</script>

<style>

.selected {
  background: rgba(var(--vs-primary), 0.1) !important;
}

.signature {
  width: 150px;
  height: 50px;
  border: dotted 1px green;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.signature .stamp {
  position: relative;
  height: 50px;
  width: 50px;
  border-radius: 50px;
  background-color: rgb(0, 255, 0);
  opacity: 0.6;
  margin: 0 auto !important;
}

.signature .data {
  line-height: 12px;
  position: absolute;
  top: 1px;
}

.signature .data-item {
  font-size: 12px;
  font-family: sans-serif;
  text-align: left;
}

.signature .button-close {
  position: absolute;
  top: -5px;
  right: -2px;
  background-color: #ee5f5f;
  color: white;
  border-radius: 8px;
  padding: 0 4px;
  font-size: 10px;
  z-index: 10;
}
.positioned {
  border: 1px solid #ff9f43 !important;
  font-size: 16px;
}

</style>
